const images = {
  logo: "../static/images/tg-logo.svg",
  wizard: "../static/images/10.png",
  checkIcon: "../static/images/check.svg",
  errorIcon: "../static/images/error.svg",
  infoIcon: "../static/images/info.svg",
  successIcon: "../static/images/success.svg",
};

export { images };
